import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateAdvancedSpecializationSpecialist = () => {
  return (
    <Create
      title="Създаване на ВСД специализант"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateAdvancedSpecializationSpecialist;
